export const announceAllPassengersAreSeated = message => {
  var _liveRegion$textConte;
  if (!message) {
    return;
  }
  const liveRegion = document.querySelector('#live-region-all-passengers-seated');
  if (!liveRegion) {
    return;
  }
  const trimmedMessage = message.trim();
  const currentMessage = ((_liveRegion$textConte = liveRegion.textContent) === null || _liveRegion$textConte === void 0 ? void 0 : _liveRegion$textConte.trim()) || '';
  if (!currentMessage) {
    liveRegion.textContent = trimmedMessage;
    return;
  }
  if (!currentMessage.endsWith('.')) {
    liveRegion.textContent = `${currentMessage}.`;
    return;
  }
  if (trimmedMessage.endsWith('.')) {
    liveRegion.textContent = trimmedMessage.slice(0, -1);
    return;
  }
  liveRegion.textContent = trimmedMessage;
};
//# sourceMappingURL=a11yUtils.js.map